import {createAction} from "@reduxjs/toolkit";

export const setFeaturedEvents = createAction('SET_FEATURED_EVENTS');